import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../../lib/motion";

const testimonials = [
  {
    quote:
      "Before working together, everything in my business felt a bit all over the place. I didn't have a clear onboarding process and was constantly repeating myself with clients. After everything was set up, the difference was immediate. My systems are now structured, my communication is consistent, and I feel much more in control. It's taken a huge amount of pressure off my day-to-day. Everything just runs properly now.",
  },
  {
    quote:
      "I knew my business needed structure, but I didn't realise how much it was affecting how I showed up. Since having everything set up, my processes feel clear and professional, and my clients have noticed the difference straight away. It's made my business feel more established and easier to manage. I finally feel like I'm operating properly, not just figuring things out as I go.",
  },
];

export default function Testimonial() {
  return (
    <section data-testid="testimonial-section" className="py-28 sm:py-40 bg-[color:var(--bg-alt)]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <motion.div {...fadeUp} className="max-w-3xl mb-20">
          <p className="overline mb-6">— Kind Words</p>
          <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[color:var(--charcoal)] leading-[1.08]">
            From the businesses
            <span className="italic text-[color:var(--gold)]"> we've structured</span>.
          </h2>
        </motion.div>

        <motion.div
          {...stagger}
          className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16"
          data-testid="testimonial-grid"
        >
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              {...fadeUp}
              data-testid={`testimonial-${i}`}
              className="bg-[color:var(--surface)] border border-[color:var(--border-light)] p-10 sm:p-14 flex flex-col"
            >
              <span
                className="font-serif-display text-[color:var(--gold)] text-6xl leading-none mb-6 select-none"
                aria-hidden="true"
              >
                &ldquo;
              </span>
              <blockquote className="font-serif-display italic text-xl sm:text-2xl text-[color:var(--charcoal)] leading-[1.55] font-light flex-1">
                {t.quote}
              </blockquote>
              <div className="mt-10 flex items-center gap-4">
                <span className="w-10 h-px bg-[color:var(--gold)]" />
                <figcaption className="overline">A Foundation Edit Client</figcaption>
              </div>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
